import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from '../src/app/environments/environment';
import config from 'devextreme/core/config'; 
// import { licenseKey } from './devextreme-license'; 

if (environment.production) {
  enableProdMode();
}

config({ licenseKey: environment.DEVEXTREME_KEY });
platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
